import axios from 'axios';
import { store } from '../store';
import { clearUser } from '../store/slice/userSlice';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3001';

const apiClient = axios.create({
  baseURL: BACKEND_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

let isLoggingOut = false;

async function logoutOnUnauthorized() {
  if (isLoggingOut) return;
  isLoggingOut = true;
  try {
    store.dispatch(clearUser());
    localStorage.removeItem('user');
    await axios.post(
      `${BACKEND_URL}/api/auth/logout`,
      {},
      {
        withCredentials: true,
      }
    );
  } catch (error) {
    console.error('Auto logout failed:', error.message);
  } finally {
    window.location.href = `${BACKEND_URL}/api/auth/login`;
  }
}

apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      // Don't auto-redirect on auth/me 401 (handled gracefully during session check)
      const url = error.config?.url || '';
      if (!url.includes('/api/auth/me')) {
        await logoutOnUnauthorized();
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;
